import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { NumberService } from '@rd/core/services/number/number.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { ButtonTheme, LoyaltyCurrency, LoyaltyProgram } from '@rd/types';
import { TransferConnectV2SettingService } from '../../services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-tcv2-loyalty-programs-list-item-desktop',
  templateUrl: './loyalty-programs-list-item-desktop.component.html',
  styleUrls: ['./loyalty-programs-list-item-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2LoyaltyProgramsListItemDesktopComponent implements OnInit {
  @HostBinding('class.rd-tcv2-loyalty-programs-list-item-desktop')
  componentClass = true;
  @HostBinding('class.hover-tile')
  hoverTile = true;
  @HostBinding('class') tailwindClasses =
    'py-6 px-4 text-center flex flex-col justify-between rounded-md';
  @Input() loyaltyProgram: LoyaltyProgram;
  @Input() loading: boolean;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;

  buttonTheme: ButtonTheme;

  constructor(
    protected loyaltyProgramHelper: LoyaltyProgramHelper,
    protected numberService: NumberService,
    protected translateService: TranslateService,
    protected iconRegistryService: IconRegistryService,
    protected transferConnectV2SettingService: TransferConnectV2SettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();

    this.buttonTheme =
      this.transferConnectV2SettingService.listItemDesktopButtonTheme;
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('equal');
  }

  getComponentRenderState(): ComponentRenderState {
    if (this.loyaltyProgram) {
      return 'content';
    } else {
      return 'loading';
    }
  }

  checkoutUrl(): string {
    return this.loyaltyProgramHelper.checkoutUrl(this.loyaltyProgram);
  }

  loyaltyProgramImageUrl(): URL | null {
    return this.loyaltyProgram.pointsTransferCapability.logoUrl;
  }

  tenantCurrencyPointsParams(): { points_amount: string; currency: string } {
    return {
      points_amount: this.tenantCurrencyPointsAmount(),
      currency: this.tenantCurrency(),
    };
  }

  targetCurrencyPointsParams(): { points_amount: string; currency: string } {
    return {
      points_amount: this.targetCurrencyPointsAmount(),
      currency: this.targetCurrency(),
    };
  }

  tenantCurrencyPointsAmount(): string {
    return this.numberService.formatNumber(
      // @ts-ignore
      this.loyaltyProgram.transferRate.minimumTransfer,
    );
  }

  tenantCurrency(): string {
    return this.translateService.instant(
      this.pointsCurrencyNameTranslationKey(),
    );
  }

  targetCurrencyPointsAmount(): string {
    return this.numberService.formatNumber(
      // @ts-ignore
      this.loyaltyProgram.transferRate.targetMinimumTransfer,
    );
  }

  targetCurrency(): string {
    // @ts-ignore
    return this.loyaltyProgram.loyaltyCurrency.name;
  }

  private pointsCurrencyNameTranslationKey(): string {
    if (
      this.transferConnectV2SettingService.loyaltyProgramNameAttribute ===
      'name'
    ) {
      return this.loyaltyCurrencySelected.name;
    } else {
      return this.loyaltyCurrencySelected.shortName;
    }
  }
}
